import _app from "@b3dotfun/sdk/global-account/app";

// Cast to any — the SDK compiled dist loses the Feathers Application type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const app = _app as any;

// Configure turnkey-auth service to ensure all methods (including listAddresses) are available
// This manually registers the service with all methods, similar to turnkeyAuthClient
// This is necessary because the SDK package might not have the latest method definitions
if (typeof window !== "undefined") {
  try {
    const connection = app.get("connection");
    if (connection && connection.service) {
      const turnkeyAuthService = connection.service("turnkey-auth");
      if (turnkeyAuthService) {
        // Re-register the turnkey-auth service with all methods including listAddresses and exportPrivateKey
        app.use("turnkey-auth", turnkeyAuthService, {
          methods: [
            "init",
            "verify",
            "send",
            "receive",
            "createWallet",
            "createWalletInSubOrg",
            "listWallet",
            "listAddresses",
            "exportPrivateKey",
          ],
        });
      }
    }
  } catch (error) {
    console.warn("Failed to configure turnkey-auth client:", error);
  }
}

export default app;
